import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] =[
    {
      "table_id": 1,
      "title": "Home",
      "nav_level": 1,
      "id": "home",
      "type": "item",
      "icon": "home",
      "icon_url": null,
      "url": "/home",
      "display_order": 1,
      "parent_id": null
    },
    {
      "table_id": 2,
      "title": "Business Insights",
      "nav_level": 1,
      "id": "dashboardManagement",
      "type": "collapsable",
      "icon": "insights",
      "icon_url": null,
      "url": null,
      "display_order": 2,
      "parent_id": null,
      "children": [
        {
          "table_id": 5,
          "title": "Analytics",
          "nav_level": 2,
          "id": "analytics",
          "type": "item",
          "icon": "add_chart",
          "icon_url": null,
          "url": "/dashboardManagement/analytics",
          "display_order": 3,
          "parent_id": 2,
          "children": [
            {
              "table_id": 67,
              "title": "Business",
              "nav_level": 3,
              "id": "businessAnalytics",
              "type": "TAB",
              "icon": "",
              "icon_url": null,
              "url": null,
              "display_order": 62,
              "parent_id": 5
            },
            {
              "table_id": 74,
              "title": "Usage Pattern",
              "nav_level": 3,
              "id": "usagePatternAnalytics",
              "type": "TAB",
              "icon": null,
              "icon_url": null,
              "url": null,
              "display_order": 63,
              "parent_id": 5
            },
            {
              "table_id": 68,
              "title": "Operations",
              "nav_level": 3,
              "id": "operationAnalytics",
              "type": "TAB",
              "icon": null,
              "icon_url": null,
              "url": null,
              "display_order": 64,
              "parent_id": 5
            },
            {
              "table_id": 69,
              "title": "Payments",
              "nav_level": 3,
              "id": "paymentAnalytics",
              "type": "TAB",
              "icon": null,
              "icon_url": null,
              "url": null,
              "display_order": 65,
              "parent_id": 5
            }
          ]
        },
        {
          "table_id": 6,
          "title": "Reports",
          "nav_level": 2,
          "id": "reports",
          "type": "collapsable",
          "icon": "summarize",
          "icon_url": "",
          "url": null,
          "display_order": 4,
          "parent_id": 2,
          "children": [
            {
              "table_id": 112,
              "title": "Monitoring Reports",
              "nav_level": 3,
              "id": "monitoringReports",
              "type": "collapsable",
              "icon": "insights",
              "icon_url": "",
              "url": null,
              "display_order": 74,
              "parent_id": 6,
              "children": [
                {
                  "table_id": 113,
                  "title": "Energy Consumed",
                  "nav_level": 4,
                  "id": "energyConsumedReport",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/monitoringReports/energyConsumedReport",
                  "display_order": 75,
                  "parent_id": 112
                },
                {
                  "table_id": 116,
                  "title": "Transactions",
                  "nav_level": 4,
                  "id": "transactionsReport",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/monitoringReports/transactionsReport",
                  "display_order": 80,
                  "parent_id": 112
                },
                {
                  "table_id": 117,
                  "title": "RFID",
                  "nav_level": 4,
                  "id": "rfidReport",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/monitoringReports/rfidReport",
                  "display_order": 81,
                  "parent_id": 112
                },
                {
                  "table_id": 118,
                  "title": "Charger Details",
                  "nav_level": 4,
                  "id": "chargerDetailsReport",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/monitoringReports/chargerDetailsReport",
                  "display_order": 82,
                  "parent_id": 112
                },
                {
                  "table_id": 119,
                  "title": "Charger Alarm",
                  "nav_level": 4,
                  "id": "chargerAlarmReport",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/monitoringReports/chargerAlarmReport",
                  "display_order": 83,
                  "parent_id": 112
                }
              ]
            },
            {
              "table_id": 120,
              "title": "Payment Reports",
              "nav_level": 3,
              "id": "paymentReports",
              "type": "collapsable",
              "icon": "insights",
              "icon_url": "",
              "url": null,
              "display_order": 84,
              "parent_id": 6,
              "children": [
                {
                  "table_id": 121,
                  "title": "Successful Payments ",
                  "nav_level": 4,
                  "id": "successfulPaymentReports",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/paymentReports/successfulPaymentReports",
                  "display_order": 85,
                  "parent_id": 120
                },
                {
                  "table_id": 122,
                  "title": "Pending Payments",
                  "nav_level": 4,
                  "id": "pendingPaymentReports",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/paymentReports/pendingPaymentReports",
                  "display_order": 86,
                  "parent_id": 120
                },
                {
                  "table_id": 123,
                  "title": "Cancelled Payments",
                  "nav_level": 4,
                  "id": "cancelPaymentReports",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/paymentReports/cancelPaymentReports",
                  "display_order": 87,
                  "parent_id": 120
                },
                {
                  "table_id": 124,
                  "title": "Refund Payments",
                  "nav_level": 4,
                  "id": "refundPaymentReports",
                  "type": "item",
                  "icon": "insights",
                  "icon_url": "",
                  "url": "/dashboardManagement/project/paymentReports/refundPaymentReports",
                  "display_order": 88,
                  "parent_id": 120
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "table_id": 3,
      "title": "Charger Management",
      "nav_level": 1,
      "id": "assetManagement",
      "type": "collapsable",
      "icon": "manage_accounts",
      "icon_url": null,
      "url": null,
      "display_order": 5,
      "parent_id": null,
      "children": [
        {
          "table_id": 7,
          "title": "Model Creation",
          "nav_level": 2,
          "id": "chargerTypeManagement",
          "type": "collapsable",
          "icon": "movie_filter",
          "icon_url": null,
          "url": null,
          "display_order": 6,
          "parent_id": 3,
          "children": [
            {
              "table_id": 12,
              "title": "Models",
              "nav_level": 3,
              "id": "crud",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/assetManagement/chargerTypeManagement/crud",
              "display_order": 7,
              "parent_id": 7
            }
          ]
        },
        {
          "table_id": 8,
          "title": "Model Variant",
          "nav_level": 2,
          "id": "chargingModel",
          "type": "collapsable",
          "icon": "movie_filter",
          "icon_url": null,
          "url": null,
          "display_order": 8,
          "parent_id": 3,
          "children": [
            {
              "table_id": 13,
              "title": "Variants",
              "nav_level": 3,
              "id": "crud",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/assetManagement/chargingModel/crud",
              "display_order": 9,
              "parent_id": 8
            }
          ]
        },
        {
          "table_id": 9,
          "title": "Publish Charger Model",
          "nav_level": 2,
          "id": "chargerManagement",
          "type": "collapsable",
          "icon": "movie_filter",
          "icon_url": null,
          "url": null,
          "display_order": 10,
          "parent_id": 3,
          "children": [
            {
              "table_id": 14,
              "title": "Manage Chargers",
              "nav_level": 3,
              "id": "crud",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/assetManagement/chargerManagement/chargers/crud",
              "display_order": 11,
              "parent_id": 9
            }
          ]
        },
        {
          "table_id": 10,
          "title": "Charger Connector - Vehicle Mapping",
          "nav_level": 2,
          "id": "vehicleManagement",
          "type": "collapsable",
          "icon": "movie_filter",
          "icon_url": null,
          "url": null,
          "display_order": 12,
          "parent_id": 3,
          "children": [
            {
              "table_id": 15,
              "title": "Set Configuration",
              "nav_level": 3,
              "id": "onBoard",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/assetManagement/vehicleManagement/onBoard/onBoard",
              "display_order": 13,
              "parent_id": 10
            }
          ]
        },
        {
          "table_id": 11,
          "title": "RFID Management",
          "nav_level": 2,
          "id": "rfidManagement",
          "type": "collapsable",
          "icon": "movie_filter",
          "icon_url": null,
          "url": null,
          "display_order": 14,
          "parent_id": 3,
          "children": [
            {
              "table_id": 16,
              "title": "Manage RFID",
              "nav_level": 3,
              "id": "rfid",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/assetManagement/rfidManagement/rfid/crud",
              "display_order": 15,
              "parent_id": 11
            },
            {
              "table_id": 17,
              "title": "CPO-RFID Mapping",
              "nav_level": 3,
              "id": "cpo-rfid",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/assetManagement/rfidManagement/cpo-rfid/crud",
              "display_order": 16,
              "parent_id": 11
            }
          ]
        }
      ]
    },
    {
      "table_id": 18,
      "title": "Dispatch Management",
      "nav_level": 1,
      "id": "chargerManagement",
      "type": "collapsable",
      "icon": "movie_filter",
      "icon_url": null,
      "url": null,
      "display_order": 17,
      "parent_id": null,
      "children": [
        {
          "table_id": 19,
          "title": "Client Sales Dispatch",
          "nav_level": 2,
          "id": "crud",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/assetManagement/chargerManagement/salesDispatch/crud",
          "display_order": 18,
          "parent_id": 18
        }
      ]
    },
    {
      "table_id": 20,
      "title": "Client Management",
      "nav_level": 1,
      "id": "clientManagement",
      "type": "collapsable",
      "icon": "group",
      "icon_url": null,
      "url": null,
      "display_order": 19,
      "parent_id": null,
      "children": [
        {
          "table_id": 21,
          "title": "Manage Client",
          "nav_level": 2,
          "id": "crud",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/clientManagement/crud",
          "display_order": 20,
          "parent_id": 20,
          "children": [
            {
              "table_id": 71,
              "title": "Clients",
              "nav_level": 3,
              "id": "list",
              "type": "TAB",
              "icon": null,
              "icon_url": null,
              "url": "list",
              "display_order": 65,
              "parent_id": 21
            },
            {
              "table_id": 70,
              "title": "Add New",
              "nav_level": 3,
              "id": "create",
              "type": "TAB",
              "icon": null,
              "icon_url": null,
              "url": "create",
              "display_order": 66,
              "parent_id": 21
            }
          ]
        },
        {
          "table_id": 60,
          "title": "Client Menu Mapping",
          "nav_level": 2,
          "id": "clientMenuMappings",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/clientManagement/clientMenuMappings",
          "display_order": 55,
          "parent_id": 20
        },
        {
          "table_id": 63,
          "title": "Client Module Mapping",
          "nav_level": 2,
          "id": "clientModuleMapping",
          "type": "collapsable",
          "icon": "movie_filter",
          "icon_url": null,
          "url": null,
          "display_order": 58,
          "parent_id": 20,
          "children": [
            {
              "table_id": 64,
              "title": "Client Module Mapping",
              "nav_level": 3,
              "id": "crud",
              "type": "item",
              "icon": "model_training",
              "icon_url": null,
              "url": "/clientManagement/clientModuleMapping/crud",
              "display_order": 59,
              "parent_id": 63
            }
          ]
        }
      ]
    },
    {
      "table_id": 22,
      "title": "CPO Management",
      "nav_level": 1,
      "id": "cpoManagement",
      "type": "collapsable",
      "icon": "settings_input_hdmi",
      "icon_url": null,
      "url": null,
      "display_order": 21,
      "parent_id": null,
      "children": [
        {
          "table_id": 23,
          "title": "Manage CPO",
          "nav_level": 2,
          "id": "crud",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/cpoManagement/crud",
          "display_order": 22,
          "parent_id": 22
        }
      ]
    },
    {
      "table_id": 24,
      "title": "Charging Station",
      "nav_level": 1,
      "id": "chargingStation",
      "type": "collapsable",
      "icon": "ev_station",
      "icon_url": null,
      "url": null,
      "display_order": 23,
      "parent_id": null,
      "children": [
        {
          "table_id": 25,
          "title": "Manage Station",
          "nav_level": 2,
          "id": "crud",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/chargingStation/crud",
          "display_order": 24,
          "parent_id": 24
        }
      ]
    },
    {
      "table_id": 26,
      "title": "OCPP Communication",
      "nav_level": 1,
      "id": "logsandHistory",
      "type": "collapsable",
      "icon": "call_split",
      "icon_url": null,
      "url": null,
      "display_order": 25,
      "parent_id": null,
      "children": [
        {
          "table_id": 27,
          "title": "OCPP Logs",
          "nav_level": 2,
          "id": "ocppLogs",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/logsandHistory/ocppLogs",
          "display_order": 26,
          "parent_id": 26
        },
        {
          "table_id": 28,
          "title": "Diagnostic and Monitoring",
          "nav_level": 2,
          "id": "chargerLogs",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/logsandHistory/chargerLogs",
          "display_order": 27,
          "parent_id": 26
        },
        {
          "table_id": 29,
          "title": "User Charging Logs",
          "nav_level": 2,
          "id": "userWiseLogs",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/logsandHistory/userWiseLogs",
          "display_order": 28,
          "parent_id": 26
        }
      ]
    },
    {
      "table_id": 34,
      "title": "User Management",
      "nav_level": 1,
      "id": "userManagement",
      "type": "collapsable",
      "icon": "group",
      "icon_url": null,
      "url": null,
      "display_order": 29,
      "parent_id": null,
      "children": [
        {
          "table_id": 35,
          "title": "Manage User",
          "nav_level": 2,
          "id": "localUser",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/userManagement/user",
          "display_order": 30,
          "parent_id": 34
        },
        {
          "table_id": 36,
          "title": "Manage Role",
          "nav_level": 2,
          "id": "mangeRole",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/userManagement/role/crud",
          "display_order": 31,
          "parent_id": 34
        },
        {
          "table_id": 37,
          "title": "Manage User-Role",
          "nav_level": 2,
          "id": "userRole",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/userManagement/user-role/crud",
          "display_order": 32,
          "parent_id": 34
        },
        {
          "table_id": 61,
          "title": "Manage Role-Activity",
          "nav_level": 2,
          "id": "roleMenuMappings",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/userManagement/role/roleMenuMappings",
          "display_order": 56,
          "parent_id": 34
        },
        {
          "table_id": 87,
          "title": "Manage User-Station",
          "nav_level": 2,
          "id": "manageUserStation",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/userManagement/manageUserStation/crud",
          "display_order": 71,
          "parent_id": 34
        }
      ]
    },
    {
      "table_id": 38,
      "title": "Corporate Management",
      "nav_level": 1,
      "id": "coprateUserManagement",
      "type": "collapsable",
      "icon": "group",
      "icon_url": null,
      "url": null,
      "display_order": 33,
      "parent_id": null,
      "children": [
        {
          "table_id": 39,
          "title": "Manage Corporate User",
          "nav_level": 2,
          "id": "coprateUser",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/coprateUserManagement/coprate-user",
          "display_order": 34,
          "parent_id": 38
        }
      ]
    },
    {
      "table_id": 40,
      "title": "Manage Geographics",
      "nav_level": 1,
      "id": "manageGeographics",
      "type": "collapsable",
      "icon": "group",
      "icon_url": null,
      "url": null,
      "display_order": 35,
      "parent_id": null,
      "children": [
        {
          "table_id": 41,
          "title": "Manage Country",
          "nav_level": 2,
          "id": "manageCountry",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/manageGeographics/manageCountry",
          "display_order": 36,
          "parent_id": 40
        },
        {
          "table_id": 42,
          "title": "Manage State",
          "nav_level": 2,
          "id": "manageState",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/manageGeographics/manageState",
          "display_order": 37,
          "parent_id": 40
        },
        {
          "table_id": 43,
          "title": "Manage City",
          "nav_level": 2,
          "id": "manageCity",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/manageGeographics/manageCity",
          "display_order": 38,
          "parent_id": 40
        },
        {
          "table_id": 75,
          "title": "Manage State-PIN",
          "nav_level": 2,
          "id": "manageStatePin",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/manageGeographics/manageStatePin",
          "display_order": 69,
          "parent_id": 40
        }
      ]
    },
    {
      "table_id": 44,
      "title": "Callback Management",
      "nav_level": 1,
      "id": "mangeCallback",
      "type": "collapsable",
      "icon": "group",
      "icon_url": null,
      "url": null,
      "display_order": 39,
      "parent_id": null,
      "children": [
        {
          "table_id": 45,
          "title": "Manage Callback",
          "nav_level": 2,
          "id": "callback",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/mangeCallback/callback/crud",
          "display_order": 40,
          "parent_id": 44
        }
      ]
    },
    {
      "table_id": 46,
      "title": "Vehicle Registration",
      "nav_level": 1,
      "id": "registration",
      "type": "collapsable",
      "icon": "app_registration",
      "icon_url": null,
      "url": null,
      "display_order": 41,
      "parent_id": null,
      "children": [
        {
          "table_id": 47,
          "title": "End Customer",
          "nav_level": 2,
          "id": "vehicle",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/registration/vehicle",
          "display_order": 42,
          "parent_id": 46
        }
      ]
    },
    {
      "table_id": 92,
      "title": "Menu Management",
      "nav_level": 1,
      "id": "menuManagement",
      "type": "collapsable",
      "icon": "movie_filter",
      "icon_url": "",
      "url": "",
      "display_order": 42,
      "parent_id": null,
      "children": [
        {
          "table_id": 93,
          "title": "Manage Menu",
          "nav_level": 2,
          "id": "crud",
          "type": "item",
          "icon": "movie_filter",
          "icon_url": null,
          "url": "/menuManagement/crud",
          "display_order": 73,
          "parent_id": 92
        }
      ]
    },
    {
      "table_id": 48,
      "title": "Booking Management",
      "nav_level": 1,
      "id": "bookingManagement",
      "type": "collapsable",
      "icon": "book",
      "icon_url": null,
      "url": null,
      "display_order": 43,
      "parent_id": null,
      "children": [
        {
          "table_id": 62,
          "title": "Manage Booking",
          "nav_level": 2,
          "id": "crud",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/booking/crud",
          "display_order": 57,
          "parent_id": 48
        },
        {
          "table_id": 65,
          "title": "Pending Bookings",
          "nav_level": 2,
          "id": "pendingBooking",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/booking/pendingBooking",
          "display_order": 60,
          "parent_id": 48
        }
      ]
    },
    {
      "table_id": 49,
      "title": "Payment Management",
      "nav_level": 1,
      "id": "paymentManagement",
      "type": "collapsable",
      "icon": "credit_score",
      "icon_url": null,
      "url": null,
      "display_order": 44,
      "parent_id": null,
      "children": [
        {
          "table_id": 66,
          "title": "Pending Payments",
          "nav_level": 2,
          "id": "pendingPayment",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/paymentManagement/pendingPayment",
          "display_order": 61,
          "parent_id": 49
        }
      ]
    },
    {
      "table_id": 50,
      "title": "3rd Party Integration",
      "nav_level": 1,
      "id": "party",
      "type": "collapsable",
      "icon": "integration_instructions",
      "icon_url": null,
      "url": null,
      "display_order": 45,
      "parent_id": null,
      "children": [
        {
          "table_id": 51,
          "title": "Alexa Integration",
          "nav_level": 2,
          "id": "alexa",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "test5",
          "display_order": 46,
          "parent_id": 50
        },
        {
          "table_id": 52,
          "title": "Google Home Integration",
          "nav_level": 2,
          "id": "googleAPI",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "test6",
          "display_order": 47,
          "parent_id": 50
        },
        {
          "table_id": 53,
          "title": "Api Integration",
          "nav_level": 2,
          "id": "apiIntegration",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "test7",
          "display_order": 48,
          "parent_id": 50
        }
      ]
    },
    {
      "table_id": 54,
      "title": "DPPD",
      "nav_level": 1,
      "id": "information",
      "type": "collapsable",
      "icon": "description",
      "icon_url": null,
      "url": null,
      "display_order": 49,
      "parent_id": null,
      "children": [
        {
          "table_id": 57,
          "title": "Privacy & Policy",
          "nav_level": 2,
          "id": "privacyAndPolicy",
          "type": "item",
          "icon": "article",
          "icon_url": null,
          "url": "/information/privacyAndPolicy",
          "display_order": 50,
          "parent_id": 54
        },
        {
          "table_id": 55,
          "title": "About Us",
          "nav_level": 2,
          "id": "aboutUs",
          "type": "item",
          "icon": "groups",
          "icon_url": null,
          "url": "/information/aboutUs",
          "display_order": 51,
          "parent_id": 54
        },
        {
          "table_id": 56,
          "title": "Contact Us",
          "nav_level": 2,
          "id": "contactUs",
          "type": "item",
          "icon": "call",
          "icon_url": null,
          "url": "/information/contactUs",
          "display_order": 52,
          "parent_id": 54
        },
        {
          "table_id": 58,
          "title": "Refund & Cancellation",
          "nav_level": 2,
          "id": "refundAndCellationPolicy",
          "type": "item",
          "icon": "article",
          "icon_url": null,
          "url": "/information/refundAndCellationPolicy",
          "display_order": 53,
          "parent_id": 54
        },
        {
          "table_id": 59,
          "title": "Product & Services",
          "nav_level": 2,
          "id": "productAndServices",
          "type": "item",
          "icon": "category",
          "icon_url": null,
          "url": "/information/productAndServices",
          "display_order": 54,
          "parent_id": 54
        }
      ]
    },
    {
      "table_id": 72,
      "title": "Error Management",
      "nav_level": 1,
      "id": "errorManagement",
      "type": "collapsable",
      "icon": "movie_filter",
      "icon_url": null,
      "url": null,
      "display_order": 67,
      "parent_id": null,
      "children": [
        {
          "table_id": 73,
          "title": "Errors",
          "nav_level": 2,
          "id": "errorList",
          "type": "item",
          "icon": "model_training",
          "icon_url": null,
          "url": "/errorManagement/errorList",
          "display_order": 68,
          "parent_id": 72
        }
      ]
    },
    {
      "table_id": 114,
      "title": "Miscellaneous",
      "nav_level": 1,
      "id": "miscellaneous",
      "type": "collapsable",
      "icon": "home",
      "icon_url": "",
      "url": "",
      "display_order": 78,
      "parent_id": null,
      "children": [
        {
          "table_id": 115,
          "title": "Ev Charging Solution",
          "nav_level": 2,
          "id": "evChargingSolution",
          "type": "item",
          "icon": "home",
          "icon_url": "",
          "url": "miscellaneous/evChargingSolution/crud",
          "display_order": 79,
          "parent_id": 114
        }
      ]
    }
  ];